// Language store — toggles between French (default) and English.
// Bambara was removed platform-wide in Iter63. Any persisted "bm"
// preference on returning users is silently migrated to "fr" by
// `read()` below — no UI prompt, no error, no data loss.
import { useEffect, useState } from "react";
import { FR, EMERGENCY_FR } from "../i18n.jsx";
import { EN_FULL, ENGLISH_EMERGENCY } from "../i18n.en.jsx";

const KEY = "rr_lang";
const SUPPORTED = ["fr", "en"];

const listeners = new Set();
const read = () => {
  try {
    const raw = localStorage.getItem(KEY) || "fr";
    if (SUPPORTED.includes(raw)) return raw;
    // Migrate legacy "bm" (Bambara) preferences to French silently.
    if (raw === "bm" || raw === "bam") {
      try { localStorage.setItem(KEY, "fr"); } catch (e) { /* noop */ void e; }
    }
    return "fr";
  } catch (_e) { return "fr"; }
};
let cur = read();

export const lang = {
  get() { return cur; },
  set(v) {
    cur = SUPPORTED.includes(v) ? v : "fr";
    try { localStorage.setItem(KEY, cur); } catch (e) { /* noop */ void e; }
    listeners.forEach((fn) => { try { fn(cur); } catch (e) { /* noop */ void e; } });
  },
  subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); },
};

const labelMap = (l) => {
  if (l === "en") {
    return Object.fromEntries(
      Object.keys(EMERGENCY_FR).map((k) => [k, {
        label: ENGLISH_EMERGENCY[k] || EMERGENCY_FR[k].label,
        subtitle: EMERGENCY_FR[k].subtitle,
      }])
    );
  }
  return EMERGENCY_FR;
};

export const dictFor = (l) => {
  if (l === "en") return EN_FULL;
  return FR;
};

export const useLang = () => {
  const [v, setV] = useState(cur);
  useEffect(() => lang.subscribe(setV), []);
  return [v, lang.set.bind(lang)];
};

export const useT = () => {
  const [l] = useLang();
  return [dictFor(l), labelMap(l), l];
};
